export default __webpack_public_path__ + "dryer-cooler.png?d01fa43bbcbf15c8e95d2de8b390d691";